import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges
} from '@angular/core';
import $ from 'jquery';
import { PositioningService } from '../../../services/positioning.service';
import { ZoomService } from '../../../services/zoom.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { PageTextService } from '../../../services/page-text.service';
import { BookFeatureService } from '../../../services/book-feature.service';
import { PageService } from '../../../services/page.service';
import { PageEditModeFactory } from '../../../utils/page-edit-modes/page-edit-mode-factory';
import { CommunicationService } from '../../../services/communication.service';
import { PageFavoriteService } from '../../../services/page-favorite.service';
import _ from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuickLinkService } from '../../../services/quick-link.service';
import { PageBookFeatures } from '../../../models/page-book-features';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { SearchService } from '../../../services/search.service';
import { FabricService } from '../../../services/fabric.service';
import { QuickLinkFactory } from '../../../models/factories/quick-link-factory';
import { SidebarService } from '../../../services/sidebar.service';
import { AbstractPageComponent } from '../page/abstract-page-component';
import { DictionaryService } from '../../../services/dictionary.service';
import { WhiteboardDrawingsService } from '@lemberger/whiteboards';
import { TasksComponent } from '../../sidebar/tasks/tasks.component';
import { PageTextBoxesComponent } from '../page/book-feature/page-text-boxes/page-text-boxes.component';
import { BookFeatureComponent } from '../page/book-feature/book-feature.component';
import { PageCanvasComponent } from '../page/book-feature/page-canvas/page-canvas.component';
import {
    QuicklinkDropdownComponent
} from '../page/book-feature/page-quick-link/quicklink-dropdown/quicklink-dropdown.component';
import { SearchResultRectComponent } from '../page/search-result-rect/search-result-rect.component';
import { PageFavoriteComponent } from '../page/book-feature/page-favorite/page-favorite.component';
import { ShareDropdownComponent } from '../page/book-feature/share-dropdown/share-dropdown.component';
import { QuicklinkOverlayComponent } from '../page/quicklink-overlay/quicklink-overlay.component';
import { PageReadspeakerComponent } from '../page/book-feature/page-readspeaker/page-readspeaker.component';
import { AsyncPipe, NgStyle } from '@angular/common';

@Component({
    selector: 'app-scroll-page',
    templateUrl: './scroll-page.component.html',
    styleUrls: ['./scroll-page.component.scss'],
    standalone: true,
    imports: [
        PageTextBoxesComponent,
        BookFeatureComponent,
        BookFeatureComponent,
        PageCanvasComponent,
        BookFeatureComponent,
        QuicklinkDropdownComponent,
        BookFeatureComponent,
        SearchResultRectComponent,
        BookFeatureComponent,
        BookFeatureComponent,
        BookFeatureComponent,
        PageFavoriteComponent,
        ShareDropdownComponent,
        QuicklinkOverlayComponent,
        PageReadspeakerComponent,
        NgStyle,
        AsyncPipe
    ]
})
export class ScrollPageComponent extends AbstractPageComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

    @Input() left: number;
    init = false;
    active = false;
    isNeighbour: boolean;

    constructor(public pageFavoriteService: PageFavoriteService,
                public bookFeatureActivationService: BookFeatureActivationService,
                public pageService: PageService,
                public pageTextService: PageTextService,
                public applicationStateService: ApplicationStateService,
                protected communicationService: CommunicationService,
                protected positioningService: PositioningService,
                protected bookFeatureService: BookFeatureService,
                protected componentFactoryResolver: ComponentFactoryResolver,
                protected pageEditModeFactory: PageEditModeFactory,
                protected changeDetectorRef: ChangeDetectorRef,
                protected zoomService: ZoomService,
                protected quickLinkService: QuickLinkService,
                protected searchService: SearchService,
                protected deviceService: DeviceDetectorService,
                protected sidebarService: SidebarService,
                protected fabricService: FabricService,
                protected dictionaryService: DictionaryService,
                protected quickLinkFactory: QuickLinkFactory,
                protected whiteboardService: WhiteboardDrawingsService) {
        super();
        this.initSubscriptions();
        this.communicationService.pageTurnAnnounced$.subscribe(() => {
            this.handlePageTurn();
        });
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.setImageSrc();
        this.$container = $(this.container.nativeElement);
        this.changeDetectorRef.detectChanges();
        this.bookFeatures = new PageBookFeatures();

        // In case the page has no saved Canvas then create a new Canvas in order for a smooth
        // workflow.
        if (!this.fabricService.pageHasDrawing(this.page.id)) {
            this.createPageDrawing();
        } else {
            this.bookFeatures.pageDrawing = this.fabricService.getPageDrawingOfPageByIndex(this.page.index);
        }

        this.fetchSearchData();
    }

    ngAfterViewInit(): void {

        this.init = true;
        if (this.applicationStateService.currentIndex === 0 && this.page.index === 0) {
            this.handlePageTurn();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateCanvas();
    }

    /**
     * Handler for window resize.
     */
    onResize(): void {
        if (this.applicationStateService.isZoomed) {
            this.zoomService.zoomToLevel(
                this.applicationStateService.zoomLevel, null);
        }
    }

    preventEvent($event): boolean {
        $event.preventDefault();
        $event.stopPropagation();

        return false;
    }

    handlePageTurn(): void {

        if (!this.init) {
            return;
        }

        // How long to wait until to load additional data (notes, text boxes, ect...)
        const timeOut = 2000;
        this.active = (this.applicationStateService.currentIndex === this.page.index);
        this.isNeighbour = this.page.index === this.applicationStateService.currentIndex + 1;

        if (this.active || this.isNeighbour) {

            if (!this.dataFetchingTimeoutId) {
                this.dataFetchingTimeoutId = setTimeout(() => {
                    this.fetchCachedData().then(() => {
                        this.fetchSolutionQuickLinksAndDropdownPossition();
                        this.fetchTextData();
                    });
                    this.pageTextBoxes.setTextBoxes(this.textBoxes);
                    if (this.sidebarService.activeComponent === TasksComponent || this.applicationStateService.currentViewMode.showTopbar) {
                        this.quickLinkService.fetchDigiTrainerContent();
                    }
                }, timeOut);
            }

        } else {

            if (this.dataFetchingTimeoutId) {
                clearTimeout(this.dataFetchingTimeoutId);
            }
            this.dataFetchingTimeoutId = undefined;
        }
    }

    protected fetchCachedData(): Promise<any> {

        return new Promise(resolve => {

            this.bookFeatureService.getCachedBookFeaturesOfPage2(this.page.index)
                .then(bookFeatures => {

                        // In case the page has no saved Canvas, store the created Canvas from the init() method in a
                        // temp variable so it won't get deleted.
                        let tmpPageDrawing;
                        if (!this.fabricService.pageHasDrawing(this.page.id)) {
                            tmpPageDrawing = this.bookFeatures.pageDrawing;
                        }

                        _.extend(this.bookFeatures, bookFeatures);

                        // In case the Page has no saved canvas. Set the temp. stored Canvas to the page's new Canvas.
                        if (!this.bookFeatures.pageDrawing) {

                            if (tmpPageDrawing) {
                                this.bookFeatures.pageDrawing = tmpPageDrawing;
                            } else {
                                this.createPageDrawing();
                            }
                        }

                        this.detectChanges();

                        if (this.childHost) {
                            this.childHost.clear();
                        }

                        resolve(null);
                    }
                );
        });
    }
}
